// extracted by mini-css-extract-plugin
module.exports = {"tracksIcon":"styles--tracksIcon--2F-lb"};